/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { PrePrintDataService } from "./pre-print-redirection.service";

@Injectable({
   providedIn: "root"
})
export class HTMLPrePrintDataService extends PrePrintDataService {
   constructor() {
      super();
   }

   public checkPrinterList = async (callback) => {};
   public getExchangePrinterList = async (callback) => {};
   public constructExchangeClientInfoReply = () => {};
}
